import * as Types from '../../../../__generated__/graphql-base-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ScreenerQuestionContextFieldsFragment = {
    __typename?: 'ScreenerQuestionContextQuestion';
    id: string;
    name: string;
    type: Types.SmartApplyScreenerQuestionType;
    labelHtml: string;
    textHtml: string;
    required: boolean;
    format?: Types.ScreenerQuestionContextQuestionFormat | null | undefined;
    min?: string | null | undefined;
    max?: string | null | undefined;
    limit?: number | null | undefined;
    minCharCount?: number | null | undefined;
    minSelectionCount?: number | null | undefined;
    maxSelectionCount?: number | null | undefined;
    groupLabel?: string | null | undefined;
    addButtonLabel?: string | null | undefined;
    outputDatePattern?: string | null | undefined;
    fileFormats: Array<string>;
    options: Array<{ __typename?: 'ScreenerQuestionContextOption'; value: string; label: string }>;
    hierarchicalOptions: Array<{
        __typename?: 'ScreenerQuestionContextHierarchicalOptionSet';
        id: string;
        condition: {
            __typename?: 'ScreenerQuestionContextCondition';
            id: string;
            values: Array<string>;
        };
        options: Array<{
            __typename?: 'ScreenerQuestionContextOption';
            value: string;
            label: string;
        }>;
    }>;
    formField:
        | {
              __typename: 'ScreenerQuestionContextFileFormField';
              fileSlots: Array<{
                  __typename?: 'ScreenerQuestionContextFileFormFieldSlot';
                  slotValue: string;
              }>;
          }
        | {
              __typename: 'ScreenerQuestionContextHierarchicalFormField';
              entries: Array<{
                  __typename?: 'ScreenerQuestionContextHierarchicalFormFieldEntry';
                  key: string;
                  entryValue: string;
              }>;
          }
        | {
              __typename: 'ScreenerQuestionContextMultiFieldFormField';
              _unused?: boolean | null | undefined;
          }
        | { __typename: 'ScreenerQuestionContextMultiValuedFormField'; values: Array<string> }
        | {
              __typename: 'ScreenerQuestionContextSingleValuedFormField';
              textValue?: string | null | undefined;
          };
};

export type SavedScreenerAnswerFragment = {
    __typename?: 'QuestionAndAnswerSmartApplyApplicationState';
    questionId: string;
    answer?:
        | {
              __typename?: 'FileAnswerSmartApplyApplicationState';
              file: {
                  __typename?: 'FileSmartApplyApplicationState';
                  name: string;
                  fileToken: string;
                  contentType: string;
                  contentHash: string;
                  downloadHash: string;
              };
          }
        | {
              __typename?: 'HierarchicalAnswerSmartApplyApplicationState';
              valueList: Array<{
                  __typename?: 'HierarchicalAnswerValueSmartApplyApplicationState';
                  id: string;
                  value: string;
              }>;
          }
        | { __typename?: 'MultiFieldAnswerSmartApplyApplicationState' }
        | {
              __typename?: 'MultiFileAnswerSmartApplyApplicationState';
              files: Array<{
                  __typename?: 'FileAnswerSmartApplyApplicationState';
                  file: {
                      __typename?: 'FileSmartApplyApplicationState';
                      name: string;
                      fileToken: string;
                      contentType: string;
                      contentHash: string;
                      downloadHash: string;
                  };
              }>;
          }
        | {
              __typename?: 'MultiTextAnswerSmartApplyApplicationState';
              valueList: Array<{
                  __typename?: 'TextAnswerSmartApplyApplicationState';
                  value: string;
              }>;
          }
        | { __typename?: 'TextAnswerSmartApplyApplicationState'; value: string }
        | null
        | undefined;
};

export type GetAutoApplyScreenerQuestionsQueryVariables = Types.Exact<{
    input: Types.SmartApplyContextInput;
    nodeId: Types.Scalars['ID']['input'];
}>;

export type GetAutoApplyScreenerQuestionsQuery = {
    __typename?: 'Query';
    smartApplyContext?:
        | {
              __typename?: 'SmartApplyContext';
              draftId: string;
              jobContext?:
                  | {
                        __typename?: 'SmartApplyJobContext';
                        employer: { __typename?: 'JobContextEmployer'; apiToken: string };
                    }
                  | null
                  | undefined;
              screenerQuestionContext?:
                  | {
                        __typename?: 'SmartApplyScreenerQuestionContext';
                        screenerQuestions: Array<{
                            __typename?: 'ScreenerQuestionContextQuestion';
                            id: string;
                            name: string;
                            type: Types.SmartApplyScreenerQuestionType;
                            labelHtml: string;
                            textHtml: string;
                            required: boolean;
                            format?: Types.ScreenerQuestionContextQuestionFormat | null | undefined;
                            min?: string | null | undefined;
                            max?: string | null | undefined;
                            limit?: number | null | undefined;
                            minCharCount?: number | null | undefined;
                            minSelectionCount?: number | null | undefined;
                            maxSelectionCount?: number | null | undefined;
                            groupLabel?: string | null | undefined;
                            addButtonLabel?: string | null | undefined;
                            outputDatePattern?: string | null | undefined;
                            fileFormats: Array<string>;
                            options: Array<{
                                __typename?: 'ScreenerQuestionContextOption';
                                value: string;
                                label: string;
                            }>;
                            hierarchicalOptions: Array<{
                                __typename?: 'ScreenerQuestionContextHierarchicalOptionSet';
                                id: string;
                                condition: {
                                    __typename?: 'ScreenerQuestionContextCondition';
                                    id: string;
                                    values: Array<string>;
                                };
                                options: Array<{
                                    __typename?: 'ScreenerQuestionContextOption';
                                    value: string;
                                    label: string;
                                }>;
                            }>;
                            formField:
                                | {
                                      __typename: 'ScreenerQuestionContextFileFormField';
                                      fileSlots: Array<{
                                          __typename?: 'ScreenerQuestionContextFileFormFieldSlot';
                                          slotValue: string;
                                      }>;
                                  }
                                | {
                                      __typename: 'ScreenerQuestionContextHierarchicalFormField';
                                      entries: Array<{
                                          __typename?: 'ScreenerQuestionContextHierarchicalFormFieldEntry';
                                          key: string;
                                          entryValue: string;
                                      }>;
                                  }
                                | {
                                      __typename: 'ScreenerQuestionContextMultiFieldFormField';
                                      _unused?: boolean | null | undefined;
                                  }
                                | {
                                      __typename: 'ScreenerQuestionContextMultiValuedFormField';
                                      values: Array<string>;
                                  }
                                | {
                                      __typename: 'ScreenerQuestionContextSingleValuedFormField';
                                      textValue?: string | null | undefined;
                                  };
                        }>;
                    }
                  | null
                  | undefined;
          }
        | null
        | undefined;
    smartApplyApplicationState?:
        | { __typename?: 'AIInterviewInterview' }
        | { __typename?: 'AIJobManSubsetConfiguration' }
        | { __typename?: 'AdhocEmployerInterviewIntent' }
        | { __typename?: 'AdhocJobseekerInterviewIntent' }
        | { __typename?: 'AiDocument' }
        | { __typename?: 'AnalyticsMetricsDataResult' }
        | { __typename?: 'ApplicationDraft' }
        | { __typename?: 'Appointment' }
        | { __typename?: 'AtsSyncCandidateSyncApplication' }
        | { __typename?: 'AtsSyncCandidateSyncIndeedApplyApplicationAsset' }
        | { __typename?: 'AtsSyncCandidateSyncInterestedCandidateAsset' }
        | { __typename?: 'AtsSyncCandidateSyncSmartScreeningUpdateAsset' }
        | { __typename?: 'AuditEvent' }
        | { __typename?: 'AutomatableActionResult' }
        | { __typename?: 'AutomatableCalendlyResult' }
        | { __typename?: 'AutomatableEngagementResult' }
        | { __typename?: 'AutomatableKeyValueResult' }
        | { __typename?: 'AutomatableScreenerResult' }
        | { __typename?: 'AutomatableUpdateCandidateResult' }
        | { __typename?: 'AutosourcerBulkEnableTask' }
        | { __typename?: 'Availability' }
        | { __typename?: 'BillingAccount' }
        | { __typename?: 'BillingCreditMemo' }
        | { __typename?: 'BillingDebitMemo' }
        | { __typename?: 'BillingIdentifier' }
        | { __typename?: 'BillingInvoice' }
        | { __typename?: 'BillingPayment' }
        | { __typename?: 'BillingRefund' }
        | { __typename?: 'BulkJobContentOptimization' }
        | { __typename?: 'CalendarConfiguration' }
        | { __typename?: 'Campaign' }
        | { __typename?: 'Candidate' }
        | { __typename?: 'CandidateBio' }
        | { __typename?: 'CandidateFeedbackNote' }
        | { __typename?: 'CandidateFeedbackRating' }
        | { __typename?: 'CandidateFeedbackSentiment' }
        | { __typename?: 'CandidateJourney' }
        | { __typename?: 'CandidateJourneyGroup' }
        | { __typename?: 'CandidateJourneyStage' }
        | { __typename?: 'CandidateSubmission' }
        | { __typename?: 'CandidateSubmissionGroup' }
        | { __typename?: 'CandidateSyncSmartSourcingExportResourceHistory' }
        | { __typename?: 'CategoricalOQVTTaxonomy' }
        | { __typename?: 'ChannelNotification' }
        | { __typename?: 'ChatConversation' }
        | { __typename?: 'ChatConversationAttachment' }
        | { __typename?: 'ChatConversationMessage' }
        | { __typename?: 'CollaborationRequest' }
        | { __typename?: 'CommunicationsHubRequest' }
        | { __typename?: 'CompanyAlert' }
        | { __typename?: 'Conversation' }
        | { __typename?: 'ConversationEvent' }
        | { __typename?: 'CraveComplianceDocument' }
        | { __typename?: 'CraveEmployerDocument' }
        | { __typename?: 'CreditAllocation' }
        | { __typename?: 'CurrentCandidateSubmissionStatus' }
        | { __typename?: 'DedicatedSchedulingFormat' }
        | { __typename?: 'DeepSourcingSession' }
        | { __typename?: 'DeepSourcingSessionHighlightMatch' }
        | { __typename?: 'EjpAutomationTransaction' }
        | { __typename?: 'EjpGroup' }
        | { __typename?: 'EjpJobMatchAutomation' }
        | { __typename?: 'EmployerAdminAction' }
        | { __typename?: 'EmployerAiAutomationsGuardrail' }
        | { __typename?: 'EmployerAnalyticsSavedView' }
        | { __typename?: 'EmployerAutomation' }
        | { __typename?: 'EmployerBillingContractDeal' }
        | { __typename?: 'EmployerBillingContractLead' }
        | { __typename?: 'EmployerDealBonusCredit' }
        | { __typename?: 'EmployerEntity' }
        | { __typename?: 'EmployerHierarchy' }
        | { __typename?: 'EmployerHiringEvent' }
        | { __typename?: 'EmployerHiringEventRsvp' }
        | { __typename?: 'EmployerIntegration' }
        | { __typename?: 'EmployerJob' }
        | { __typename?: 'EmployerJobBatchEdit' }
        | { __typename?: 'EmployerJobGroup' }
        | { __typename?: 'EmployerJobHiringAdvice' }
        | { __typename?: 'EmployerJobTag' }
        | { __typename?: 'EmployerOrganization' }
        | { __typename?: 'EmployerOrganizationType' }
        | { __typename?: 'EmployerOrganizationUser' }
        | { __typename?: 'EmployerOrganizationalUnit' }
        | { __typename?: 'EmployerOrganizationalUnitUser' }
        | { __typename?: 'EmployerRegistration' }
        | { __typename?: 'EmployerUser' }
        | { __typename?: 'EmployerUserCandidateSourcingSettings' }
        | { __typename?: 'EmployerUserCandidateSourcingUxFeatures' }
        | { __typename?: 'EmployerUserGroup' }
        | { __typename?: 'EmployerUserHiringProfile' }
        | { __typename?: 'EmployerUserSettings' }
        | { __typename?: 'EvaluateWorkflow' }
        | { __typename?: 'EvaluateWorkflowStep' }
        | { __typename?: 'ExternalAtsLink' }
        | { __typename?: 'ExternalJobPost' }
        | { __typename?: 'FlexAgencyChargeRateOverride' }
        | { __typename?: 'FlexBurdenProfile' }
        | { __typename?: 'FlexExternalIntegration' }
        | { __typename?: 'FlexExternalIntegrationSyncRun' }
        | { __typename?: 'FlexPlacementMargin' }
        | { __typename?: 'FlexPlatformMargin' }
        | { __typename?: 'FlexRateCard' }
        | { __typename?: 'FlexShiftRateType' }
        | { __typename?: 'FlexTimeDependentRate' }
        | { __typename?: 'GhostwriterApplication' }
        | { __typename?: 'GhostwriterFieldResponse' }
        | { __typename?: 'GhostwriterFormField' }
        | { __typename?: 'GhostwriterFormFieldGroup' }
        | { __typename?: 'GhostwriterJob' }
        | { __typename?: 'GhostwriterResponseGroup' }
        | { __typename?: 'GhostwriterResponseSet' }
        | { __typename?: 'HiringLabNationalAI' }
        | { __typename?: 'HiringLabNationalPayTransparency' }
        | { __typename?: 'HiringLabNationalPosting' }
        | { __typename?: 'HiringLabNationalRemote' }
        | { __typename?: 'HiringLabNationalWage' }
        | { __typename?: 'HiringLabRegionalPayTransparency' }
        | { __typename?: 'HiringLabRegionalPosting' }
        | { __typename?: 'HiringLabSectoralPayTransparency' }
        | { __typename?: 'HiringLabSectoralPosting' }
        | { __typename?: 'HiringLabSectoralRemote' }
        | { __typename?: 'HiringLabSectoralWage' }
        | { __typename?: 'HiringProfile' }
        | { __typename?: 'IAMConfiguration' }
        | { __typename?: 'InboundCandidateSyncConfiguration' }
        | { __typename?: 'InboundCandidateSyncResult' }
        | { __typename?: 'IndeedAssistantContextIndex' }
        | { __typename?: 'IndeedAssistantContextItemIngestionJob' }
        | { __typename?: 'IndeedAssistantEmbeddingProvider' }
        | { __typename?: 'InsertionOrder' }
        | { __typename?: 'InterviewLobby' }
        | { __typename?: 'InterviewLobbyAppointment' }
        | { __typename?: 'InterviewNowSession' }
        | { __typename?: 'InterviewRoom' }
        | { __typename?: 'InterviewTemplate' }
        | { __typename?: 'JPCorporateNumberCompanyData' }
        | { __typename?: 'JapanJobPostingForm' }
        | { __typename?: 'JobAlert' }
        | { __typename?: 'JobApplication' }
        | { __typename?: 'JobContentForm' }
        | { __typename?: 'JobMonetizationPolicy' }
        | { __typename?: 'JobPost' }
        | { __typename?: 'JobPostingForm' }
        | { __typename?: 'JobSeekerInvite' }
        | { __typename?: 'JobseekerInterviewNowSession' }
        | { __typename?: 'LibraryAuthor' }
        | { __typename?: 'LibraryBook' }
        | { __typename?: 'ManagedEmployerInterviewIntent' }
        | { __typename?: 'ManagedJobseekerInterviewIntent' }
        | { __typename?: 'MessageTemplate' }
        | { __typename?: 'MetadataCatalogDataAsset' }
        | { __typename?: 'MetadataCatalogDataAssetField' }
        | { __typename?: 'MultiLocationJobPostingForm' }
        | { __typename?: 'Notice' }
        | { __typename?: 'OneLogActivity' }
        | { __typename?: 'PartnerWebhook' }
        | { __typename?: 'PathfinderM2Suggestion' }
        | { __typename?: 'PathfinderSkill' }
        | { __typename?: 'PayrollInstantPayAdvance' }
        | { __typename?: 'PayrollPaycheck' }
        | { __typename?: 'PayrollShift' }
        | { __typename?: 'PphContract' }
        | { __typename?: 'PreApplyCandidate' }
        | { __typename?: 'Project' }
        | { __typename?: 'ProjectJobseeker' }
        | { __typename?: 'Proposal' }
        | { __typename?: 'RematchInvitation' }
        | { __typename?: 'ResourceGroup' }
        | { __typename?: 'RestrictedInterviewLobby' }
        | { __typename?: 'SchedulingParticipantGroup' }
        | { __typename?: 'ScoutAIDocument' }
        | { __typename?: 'ScoutApplication' }
        | { __typename?: 'ScoutChatMessage' }
        | { __typename?: 'ScoutConversation' }
        | { __typename?: 'ScoutDeepSourcingResult' }
        | { __typename?: 'ScoutMatchMeter' }
        | { __typename?: 'ScoutMatchProfile' }
        | { __typename?: 'ScoutMatchProfileDocument' }
        | {
              __typename?: 'SmartApplyApplicationState';
              id: string;
              questionsAndAnswers?:
                  | {
                        __typename?: 'ScreenerQuestionsAndAnswersSmartApplyApplicationState';
                        screener: Array<{
                            __typename?: 'QuestionAndAnswerSmartApplyApplicationState';
                            questionId: string;
                            answer?:
                                | {
                                      __typename?: 'FileAnswerSmartApplyApplicationState';
                                      file: {
                                          __typename?: 'FileSmartApplyApplicationState';
                                          name: string;
                                          fileToken: string;
                                          contentType: string;
                                          contentHash: string;
                                          downloadHash: string;
                                      };
                                  }
                                | {
                                      __typename?: 'HierarchicalAnswerSmartApplyApplicationState';
                                      valueList: Array<{
                                          __typename?: 'HierarchicalAnswerValueSmartApplyApplicationState';
                                          id: string;
                                          value: string;
                                      }>;
                                  }
                                | { __typename?: 'MultiFieldAnswerSmartApplyApplicationState' }
                                | {
                                      __typename?: 'MultiFileAnswerSmartApplyApplicationState';
                                      files: Array<{
                                          __typename?: 'FileAnswerSmartApplyApplicationState';
                                          file: {
                                              __typename?: 'FileSmartApplyApplicationState';
                                              name: string;
                                              fileToken: string;
                                              contentType: string;
                                              contentHash: string;
                                              downloadHash: string;
                                          };
                                      }>;
                                  }
                                | {
                                      __typename?: 'MultiTextAnswerSmartApplyApplicationState';
                                      valueList: Array<{
                                          __typename?: 'TextAnswerSmartApplyApplicationState';
                                          value: string;
                                      }>;
                                  }
                                | {
                                      __typename?: 'TextAnswerSmartApplyApplicationState';
                                      value: string;
                                  }
                                | null
                                | undefined;
                        }>;
                    }
                  | null
                  | undefined;
          }
        | { __typename?: 'SocialImpactJobseeker' }
        | { __typename?: 'SocialImpactPartner' }
        | { __typename?: 'SocialImpactPartnerAdmin' }
        | { __typename?: 'SourcingHitlPendingQuestion' }
        | { __typename?: 'SsiEmployerLink' }
        | { __typename?: 'SsiNotificationRule' }
        | { __typename?: 'SsiPlatformInstallation' }
        | { __typename?: 'StoredDataReport' }
        | { __typename?: 'SystemNotice' }
        | { __typename?: 'TalentProjectCandidateNote' }
        | { __typename?: 'TalentSubscription' }
        | { __typename?: 'TalentSubscriptionTemplate' }
        | { __typename?: 'TerraformModule' }
        | { __typename?: 'TerraformProject' }
        | { __typename?: 'TerraformTeam' }
        | { __typename?: 'TerraformWorkspace' }
        | { __typename?: 'TestEntity' }
        | { __typename?: 'TrustedMediaNetworkJob' }
        | { __typename?: 'WorkedShift' }
        | { __typename?: 'WorkedShiftMeal' }
        | { __typename?: 'WorkflowConfigRule' }
        | null
        | undefined;
};

export type SaveSQApplicationDataMutationVariables = Types.Exact<{
    draftInput: Types.SmartApplyApplicationStateInput;
    sqInput: Types.UpdateQuestionsAndAnswersSmartApplyApplicationStateInput;
}>;

export type SaveSQApplicationDataMutation = {
    __typename?: 'Mutation';
    smartApplyApplicationState: {
        __typename?: 'SmartApplyApplicationStateMutations';
        updateScreenerQuestionAnswers?:
            | {
                  __typename?: 'UpdateScreenerQuestionAnswersSmartApplyApplicationState';
                  payload: {
                      __typename?: 'ScreenerQuestionsAndAnswersSmartApplyApplicationState';
                      screener: Array<{
                          __typename?: 'QuestionAndAnswerSmartApplyApplicationState';
                          questionId: string;
                          answer?:
                              | {
                                    __typename?: 'FileAnswerSmartApplyApplicationState';
                                    file: {
                                        __typename?: 'FileSmartApplyApplicationState';
                                        name: string;
                                        fileToken: string;
                                        contentType: string;
                                        contentHash: string;
                                        downloadHash: string;
                                    };
                                }
                              | {
                                    __typename?: 'HierarchicalAnswerSmartApplyApplicationState';
                                    valueList: Array<{
                                        __typename?: 'HierarchicalAnswerValueSmartApplyApplicationState';
                                        id: string;
                                        value: string;
                                    }>;
                                }
                              | { __typename?: 'MultiFieldAnswerSmartApplyApplicationState' }
                              | {
                                    __typename?: 'MultiFileAnswerSmartApplyApplicationState';
                                    files: Array<{
                                        __typename?: 'FileAnswerSmartApplyApplicationState';
                                        file: {
                                            __typename?: 'FileSmartApplyApplicationState';
                                            name: string;
                                            fileToken: string;
                                            contentType: string;
                                            contentHash: string;
                                            downloadHash: string;
                                        };
                                    }>;
                                }
                              | {
                                    __typename?: 'MultiTextAnswerSmartApplyApplicationState';
                                    valueList: Array<{
                                        __typename?: 'TextAnswerSmartApplyApplicationState';
                                        value: string;
                                    }>;
                                }
                              | {
                                    __typename?: 'TextAnswerSmartApplyApplicationState';
                                    value: string;
                                }
                              | null
                              | undefined;
                      }>;
                  };
              }
            | null
            | undefined;
    };
};

export const ScreenerQuestionContextFieldsFragmentDoc = gql`
    fragment ScreenerQuestionContextFields on ScreenerQuestionContextQuestion {
        id
        name
        type
        labelHtml
        textHtml
        required
        format
        min
        max
        limit
        minCharCount
        minSelectionCount
        maxSelectionCount
        groupLabel
        addButtonLabel
        outputDatePattern
        fileFormats
        options {
            value
            label
        }
        hierarchicalOptions {
            id
            condition {
                id
                values
            }
            options {
                value
                label
            }
        }
        formField {
            __typename
            ... on ScreenerQuestionContextSingleValuedFormField {
                textValue
            }
            ... on ScreenerQuestionContextMultiValuedFormField {
                values
            }
            ... on ScreenerQuestionContextHierarchicalFormField {
                entries {
                    key
                    entryValue
                }
            }
            ... on ScreenerQuestionContextFileFormField {
                fileSlots {
                    slotValue
                }
            }
            ... on ScreenerQuestionContextMultiFieldFormField {
                _unused
            }
        }
    }
`;
export const SavedScreenerAnswerFragmentDoc = gql`
    fragment SavedScreenerAnswer on QuestionAndAnswerSmartApplyApplicationState {
        questionId
        answer {
            ... on TextAnswerSmartApplyApplicationState {
                value
            }
            ... on MultiTextAnswerSmartApplyApplicationState {
                valueList {
                    value
                }
            }
            ... on HierarchicalAnswerSmartApplyApplicationState {
                valueList {
                    id
                    value
                }
            }
            ... on FileAnswerSmartApplyApplicationState {
                file {
                    name
                    fileToken
                    contentType
                    contentHash
                    downloadHash
                }
            }
            ... on MultiFileAnswerSmartApplyApplicationState {
                files {
                    file {
                        name
                        fileToken
                        contentType
                        contentHash
                        downloadHash
                    }
                }
            }
        }
    }
`;
export const GetAutoApplyScreenerQuestionsDocument = gql`
    query GetAutoApplyScreenerQuestions($input: SmartApplyContextInput!, $nodeId: ID!) {
        smartApplyContext(input: $input) {
            draftId
            jobContext {
                employer {
                    apiToken
                }
            }
            screenerQuestionContext {
                screenerQuestions {
                    ...ScreenerQuestionContextFields
                }
            }
        }
        smartApplyApplicationState: node(id: $nodeId) {
            ... on SmartApplyApplicationState {
                id
                questionsAndAnswers {
                    screener {
                        ...SavedScreenerAnswer
                    }
                }
            }
        }
    }
    ${ScreenerQuestionContextFieldsFragmentDoc}
    ${SavedScreenerAnswerFragmentDoc}
`;

/**
 * __useGetAutoApplyScreenerQuestionsQuery__
 *
 * To run a query within a React component, call `useGetAutoApplyScreenerQuestionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAutoApplyScreenerQuestionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAutoApplyScreenerQuestionsQuery({
 *   variables: {
 *      input: // value for 'input'
 *      nodeId: // value for 'nodeId'
 *   },
 * });
 */
export function useGetAutoApplyScreenerQuestionsQuery(
    baseOptions: Apollo.QueryHookOptions<
        GetAutoApplyScreenerQuestionsQuery,
        GetAutoApplyScreenerQuestionsQueryVariables
    > &
        (
            | { variables: GetAutoApplyScreenerQuestionsQueryVariables; skip?: boolean }
            | { skip: boolean }
        ),
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<
        GetAutoApplyScreenerQuestionsQuery,
        GetAutoApplyScreenerQuestionsQueryVariables
    >(GetAutoApplyScreenerQuestionsDocument, options);
}
export function useGetAutoApplyScreenerQuestionsLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetAutoApplyScreenerQuestionsQuery,
        GetAutoApplyScreenerQuestionsQueryVariables
    >,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<
        GetAutoApplyScreenerQuestionsQuery,
        GetAutoApplyScreenerQuestionsQueryVariables
    >(GetAutoApplyScreenerQuestionsDocument, options);
}
export function useGetAutoApplyScreenerQuestionsSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetAutoApplyScreenerQuestionsQuery,
              GetAutoApplyScreenerQuestionsQueryVariables
          >,
) {
    const options =
        baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<
        GetAutoApplyScreenerQuestionsQuery,
        GetAutoApplyScreenerQuestionsQueryVariables
    >(GetAutoApplyScreenerQuestionsDocument, options);
}
export type GetAutoApplyScreenerQuestionsQueryHookResult = ReturnType<
    typeof useGetAutoApplyScreenerQuestionsQuery
>;
export type GetAutoApplyScreenerQuestionsLazyQueryHookResult = ReturnType<
    typeof useGetAutoApplyScreenerQuestionsLazyQuery
>;
export type GetAutoApplyScreenerQuestionsSuspenseQueryHookResult = ReturnType<
    typeof useGetAutoApplyScreenerQuestionsSuspenseQuery
>;
export type GetAutoApplyScreenerQuestionsQueryResult = Apollo.QueryResult<
    GetAutoApplyScreenerQuestionsQuery,
    GetAutoApplyScreenerQuestionsQueryVariables
>;
export const SaveSQApplicationDataDocument = gql`
    mutation SaveSQApplicationData(
        $draftInput: SmartApplyApplicationStateInput!
        $sqInput: UpdateQuestionsAndAnswersSmartApplyApplicationStateInput!
    ) {
        smartApplyApplicationState(input: $draftInput) {
            updateScreenerQuestionAnswers(input: $sqInput) {
                payload {
                    screener {
                        ...SavedScreenerAnswer
                    }
                }
            }
        }
    }
    ${SavedScreenerAnswerFragmentDoc}
`;
export type SaveSQApplicationDataMutationFn = Apollo.MutationFunction<
    SaveSQApplicationDataMutation,
    SaveSQApplicationDataMutationVariables
>;

/**
 * __useSaveSQApplicationDataMutation__
 *
 * To run a mutation, you first call `useSaveSQApplicationDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveSQApplicationDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveSqApplicationDataMutation, { data, loading, error }] = useSaveSQApplicationDataMutation({
 *   variables: {
 *      draftInput: // value for 'draftInput'
 *      sqInput: // value for 'sqInput'
 *   },
 * });
 */
export function useSaveSQApplicationDataMutation(
    baseOptions?: Apollo.MutationHookOptions<
        SaveSQApplicationDataMutation,
        SaveSQApplicationDataMutationVariables
    >,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation<
        SaveSQApplicationDataMutation,
        SaveSQApplicationDataMutationVariables
    >(SaveSQApplicationDataDocument, options);
}
export type SaveSQApplicationDataMutationHookResult = ReturnType<
    typeof useSaveSQApplicationDataMutation
>;
export type SaveSQApplicationDataMutationResult =
    Apollo.MutationResult<SaveSQApplicationDataMutation>;
export type SaveSQApplicationDataMutationOptions = Apollo.BaseMutationOptions<
    SaveSQApplicationDataMutation,
    SaveSQApplicationDataMutationVariables
>;
